import Navbar from "./components/navBar/Navbar";
import Intro from "./components/intro/Intro";
import Skills from "./components/skills/Skills";
import Tech from "./components/technologies/Tech";
import Portfolio from "./components/portfolio/Portfolio";
import Contact from "./components/contact/Contact";
import Education from "./components/education/Education";
import Twritting from "./components/technicalWritting/Twritting";

function App() {
  return (
    <div className="App">
      <Navbar />
      <Intro />
      <Skills />
      <Tech />
      <Education />
      <Portfolio />
      <Twritting />
      <Contact />
      {/* <Footer/> */}
    </div>
  );
}

export default App;
